import React from "react";

export const CLOSING_DAY_LAST = "last";

const pad2 = (value) => String(value).padStart(2, "0");

export const localTodayYmd = () => {
  const today = new Date();
  return `${today.getFullYear()}-${pad2(today.getMonth() + 1)}-${pad2(today.getDate())}`;
};

export const getClosingDateForRow = (rowDate, closingDay = CLOSING_DAY_LAST) => {
  if (!rowDate) return "";
  const [yearText, monthText] = String(rowDate).split("-");
  const year = Number(yearText);
  const month = Number(monthText);
  if (!Number.isFinite(year) || !Number.isFinite(month)) return "";

  const lastDay = new Date(year, month, 0).getDate();
  const selectedDay =
    closingDay === CLOSING_DAY_LAST
      ? lastDay
      : Math.min(Math.max(Number(closingDay) || lastDay, 1), lastDay);

  return `${year}-${pad2(month)}-${pad2(selectedDay)}`;
};

const getRowMonth = (rowDate) => {
  if (!rowDate) return "";
  const [yearText, monthText] = String(rowDate).split("-");
  return yearText && monthText ? `${yearText}-${monthText}` : "";
};

export const applyClosingDateToRows = async (
  supabase,
  rows = [],
  closingDay = CLOSING_DAY_LAST,
  targetMonth = ""
) => {
  const today = localTodayYmd();
  const idsByClosingDate = new Map();

  rows.forEach((row) => {
    if (!row?.id || row.misu_date) return;
    if (!targetMonth || getRowMonth(row.date) !== targetMonth) return;

    const closingDate = getClosingDateForRow(row.date, closingDay);
    if (!closingDate || closingDate > today) return;

    const ids = idsByClosingDate.get(closingDate) || [];
    ids.push(row.id);
    idsByClosingDate.set(closingDate, ids);
  });

  for (const [closingDate, ids] of idsByClosingDate.entries()) {
    const { error } = await supabase
      .from("reservations")
      .update({ misu_date: closingDate })
      .in("id", ids);
    if (error) throw error;
  }

  if (idsByClosingDate.size === 0) return rows;

  return rows.map((row) => {
    if (!targetMonth || getRowMonth(row.date) !== targetMonth) return row;
    const closingDate = getClosingDateForRow(row.date, closingDay);
    const shouldClose = row?.id && !row.misu_date && closingDate && closingDate <= today;
    return shouldClose ? { ...row, misu_date: closingDate } : row;
  });
};

export const markRowsPaidByClosingDate = async (supabase, rows = [], closingDay = CLOSING_DAY_LAST) => {
  const unpaidRows = rows.filter((row) => row?.id && !row.misu_date);
  if (unpaidRows.length === 0) return 0;

  const idsByClosingDate = new Map();
  unpaidRows.forEach((row) => {
    const closingDate = getClosingDateForRow(row.date, closingDay) || localTodayYmd();
    const ids = idsByClosingDate.get(closingDate) || [];
    ids.push(row.id);
    idsByClosingDate.set(closingDate, ids);
  });

  for (const [closingDate, ids] of idsByClosingDate.entries()) {
    const { error } = await supabase
      .from("reservations")
      .update({ misu_date: closingDate })
      .in("id", ids);
    if (error) throw error;
  }

  return unpaidRows.length;
};

export function ClosingDaySelect({ closingDay, onChange }) {
  return (
    <label className="flex items-center gap-2 text-sm">
      <span className="font-semibold">마감 날짜</span>
      <select
        value={closingDay}
        onChange={(e) => onChange(e.target.value)}
        className="h-8 rounded border border-gray-300 bg-white px-2 text-sm"
      >
        <option value={CLOSING_DAY_LAST}>매달 마지막 날</option>
        {Array.from({ length: 31 }, (_, index) => {
          const day = index + 1;
          return (
            <option key={day} value={String(day)}>
              {day}일
            </option>
          );
        })}
      </select>
    </label>
  );
}
